import { HTTP_STATUS_BAD_REQUEST, HTTP_STATUS_INTERNAL_SERVER_ERROR, HTTP_STATUS_NOT_FOUND, HTTP_STATUS_OK } from "src/constants/http-status";
import { ErrorPageCode, IHead } from "src/types/layout";

export class UnexpectedStatusCodeError extends Error {
    constructor(statusCode: number) {
        const message = `Unexpected statusCode "${statusCode}" provided by backend`;
        super(message);
    }
}

export const getErrorPageCode = (statusCode: number): ErrorPageCode | null => {
    switch (statusCode) {
        case HTTP_STATUS_OK:
            return null;
        case HTTP_STATUS_BAD_REQUEST:
        case HTTP_STATUS_NOT_FOUND:
            return HTTP_STATUS_NOT_FOUND;
        case HTTP_STATUS_INTERNAL_SERVER_ERROR:
            return HTTP_STATUS_INTERNAL_SERVER_ERROR;
        default:
            throw new UnexpectedStatusCodeError(statusCode);
    }
};

export const getErrorPageHeadData = (statusCode: number): IHead => ({
    title: `${statusCode === HTTP_STATUS_NOT_FOUND ? "Not found" : "Server error"} | wikifolio.com`,
    description: statusCode === HTTP_STATUS_NOT_FOUND ? "Page not found" : "Internal server error",
    noIndex: true,
    version: "1.0.0.0",
    rssFeedUrl: "/de/de/blog/rss",
    openSearchUrl: "/umbraco/surface/opensearch/getxml",
    serverName: "PROD",
    traceId: "",
    canonicalUrl: "",
    alternativeUrl: {},
    customImageUrl: null,
});
